import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api/v1',
  timeout: 12000,
});

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('spa_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res,
  async err => {
    const original = err.config;
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const refresh = localStorage.getItem('spa_refresh');
        const { data } = await axios.post('/api/v1/auth/refresh-token', { refreshToken: refresh });
        localStorage.setItem('spa_token', data.data.accessToken);
        original.headers.Authorization = `Bearer ${data.data.accessToken}`;
        return api(original);
      } catch {
        localStorage.removeItem('spa_token');
        localStorage.removeItem('spa_refresh');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const publicAPI = {
  // Content
  page:    (slug) => api.get(`/pages/${slug}`),
  articles:(p)    => api.get('/articles', { params: { ...p, status:'published' } }),
  article: (slug) => api.get(`/articles/${slug}`),

  // Services — no hardcoded status filter, backend handles public visibility
  services:      (p) => api.get('/services', { params: p }),
  serviceBySlug: (s) => api.get(`/services/${s}`),
  categories:    ()  => api.get('/services/categories'),

  // Programs
  programs:       (p)    => api.get('/programs', { params: p }),
  programBySlug:  (slug) => api.get(`/programs/${slug}`),
  programDomains: ()     => api.get('/programs/domains'),
  enroll:         (d)    => api.post('/programs/enroll', d),

  // Internships — no hardcoded status so all statuses show when needed
  internships:      (p)    => api.get('/internships', { params: p }),
  internshipBySlug: (slug) => api.get(`/internships/${slug}`),
  applyInternship:  (d)    => api.post('/internships/apply', d),

  // Products
  products:          (p)    => api.get('/products', { params: p }),
  productBySlug:     (slug) => api.get(`/products/${slug}`),
  productCategories: ()     => api.get('/products/categories'),
  orderProduct:      (id,d) => api.post(`/products/${id}/order`, d),

  // Certificates
  verifyCertificate: (hash) => api.get(`/certificates/verify/${hash}`),

  // Ecosystem
  ecosystem: (p) => api.get('/ecosystem', { params: p }),

  // Engagement
  contact:     (d) => api.post('/contact', d),
  apply:       (d) => api.post('/applications', d),
  supportPkgs: ()  => api.get('/support-packages'),
  donate:      (d) => api.post('/donations/initiate', d),
};

export const userAPI = {
  me:             ()  => api.get('/auth/me'),
  updateProfile:  (d) => api.put('/auth/profile', d),
  changePassword: (d) => api.put('/auth/change-password', d),
  myEnrollments:  ()  => api.get('/my/enrollments'),
  myInternships:  ()  => api.get('/my/internship-applications'),
  myCertificates: ()  => api.get('/my/certificates'),
};

export default api;